import React, { useState } from 'react';
import styled from 'styled-components';

import useIframeFocus from 'src/hooks/useIframeFocus';

import { EMBEDDED_HOTEL_VIDEO_TEST_ID } from './constants';
import type { IEmbeddedVideo } from './types';
import VideoCover from '../VideoCover';

export const EmbeddedVideo = (props: IEmbeddedVideo) => {
  const { video, title, isMobile, onPlay } = props;
  const [isCoverVisible, setIsCoverVisible] = useState(!isMobile);

  const { video: src, cover: coverImage } = video;
  const srcWithParams = `${src}&rel=0&playsinline=1&enablejsapi=1${
    isCoverVisible ? '' : '&autoplay=1'
  }`;

  const handleCoverClick = () => {
    setIsCoverVisible(false);
  };

  useIframeFocus(onPlay);

  return (
    <>
      <VideoCoverWrapper
        onClick={handleCoverClick}
        $isCoverVisible={isCoverVisible}
      >
        <VideoCover coverImage={coverImage} title={title} />
      </VideoCoverWrapper>
      <StyledIframe
        data-testid={EMBEDDED_HOTEL_VIDEO_TEST_ID}
        className="yt_player_iframe"
        src={srcWithParams}
        title="Embedded video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        $isMobile={isMobile}
        $isCoverVisible={isCoverVisible}
      />
    </>
  );
};

const VideoCoverWrapper = styled.div<{ $isCoverVisible: boolean }>`
  position: relative;
  margin: 0 auto;

  height: 100%;
  width: auto;
  max-width: 90%;

  display: ${({ $isCoverVisible }) => ($isCoverVisible ? 'block' : 'none')};
  cursor: pointer;
`;

const StyledIframe = styled.iframe<{
  $isMobile: boolean;
  $isCoverVisible: boolean;
}>`
  display: ${({ $isCoverVisible }) => ($isCoverVisible ? 'none' : 'block')};

  aspect-ratio: 16 / 9;
  border: 0;

  height: 100%;
  width: auto;
  max-width: 90%;

  ${({ $isMobile }) =>
    $isMobile
      ? `
    margin: 0 auto;

    @keyframes fadeIn {
      0% { opacity: 0; }
      66% { opacity: 0; }
      100% { opacity: 1; }
    }
    animation: fadeIn 2s forwards;
      `
      : `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `}
`;
